// Import model
import { StartProposalGenerateAiContentRequest } from '../models/StartProposalGenerateAiContentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProposalGenerateAiContentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProposalGenerateAiContentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProposalGenerateAiContentRequest instance
   */
  static deserialize(json: string): StartProposalGenerateAiContentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProposalGenerateAiContentRequest instance
   */
  static fromObject(obj: any): StartProposalGenerateAiContentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProposalGenerateAiContentRequest');
    }


    const instance: StartProposalGenerateAiContentRequest = {
      assistantId: obj['AssistantId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProposalGenerateAiContentRequest instances
   */
  static deserializeArray(json: string): StartProposalGenerateAiContentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProposalGenerateAiContentRequest instance to a JSON string
   */
  static serialize(instance: StartProposalGenerateAiContentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProposalGenerateAiContentRequest instance to a plain object
   */
  static toObject(instance: StartProposalGenerateAiContentRequest): any {
    return {
      'AssistantId': instance.assistantId,
    };
  }

  /**
   * Serializes an array of StartProposalGenerateAiContentRequest instances to a JSON string
   */
  static serializeArray(instances: StartProposalGenerateAiContentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
